export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DSC: 'desc',
} as const;
